import CheckedItem from './CheckedItem';

export default CheckedItem;
